import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from 'react';

// Lazy loading pour code splitting - charge uniquement quand nécessaire
const Home = lazy(() => import('./Home'));
const About = lazy(() => import('./About'));
const Blog = lazy(() => import('./Blog'));
const BlogArticle = lazy(() => import('./BlogArticle'));
const Contact = lazy(() => import('./Contact'));
const LoginPage = lazy(() => import('./LoginPage'));
const TechnicianDashboard = lazy(() => import('./TechnicianDashboard'));
const AdminDashboard = lazy(() => import('./AdminDashboard'));
const ContentManagement = lazy(() => import('./ContentManagement'));
const PriceDashboard = lazy(() => import('./PriceDashboard'));
const DepannageInformatique = lazy(() => import('./DepannageInformatique'));
const DownloadPricing = lazy(() => import('./DownloadPricing'));
const MentionsLegales = lazy(() => import('./MentionsLegales'));
const RachatEntreprise = lazy(() => import('./RachatEntreprise'));
const RachatAppareilPhoto = lazy(() => import('./RachatAppareilPhoto'));
const RachatSmartphone = lazy(() => import('./RachatSmartphone'));
const RachatOrdinateur = lazy(() => import('./RachatOrdinateur'));
const RachatTablette = lazy(() => import('./RachatTablette'));
const RachatConsole = lazy(() => import('./RachatConsole'));
const RachatMontreConnectee = lazy(() => import('./RachatMontreConnectee'));
const PolitiqueConfidentialite = lazy(() => import('./PolitiqueConfidentialite'));
const CGV = lazy(() => import('./CGV'));

import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';
import { NotificationProvider } from './contexts/NotificationContext';
import { HelmetProvider } from 'react-helmet-async';

// Composant de chargement
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00BFA5] mx-auto"></div>
      <p className="mt-4 text-gray-600">Chargement...</p>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/technician" element={
              <NotificationProvider>
                <TechnicianDashboard />
              </NotificationProvider>
            } />
            <Route path="/admin" element={
              <NotificationProvider>
                <AdminDashboard />
              </NotificationProvider>
            } />
            <Route path="/content-management" element={
              <NotificationProvider>
                <ContentManagement />
              </NotificationProvider>
            } />
            <Route path="/admin/prices" element={
              <NotificationProvider>
                <PriceDashboard />
              </NotificationProvider>
            } />
            <Route path="/telecharger-grille-tarifaire" element={<DownloadPricing />} />
            <Route path="/depannage-informatique" element={<DepannageInformatique />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/rachat-entreprise" element={<RachatEntreprise />} />
            <Route path="/rachat-appareil-photo" element={<RachatAppareilPhoto />} />
            <Route path="/rachat-smartphone" element={<RachatSmartphone />} />
            <Route path="/rachat-ordinateur" element={<RachatOrdinateur />} />
            <Route path="/rachat-tablette" element={<RachatTablette />} />
            <Route path="/rachat-console" element={<RachatConsole />} />
            <Route path="/rachat-montre-connectee" element={<RachatMontreConnectee />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/cgv" element={<CGV />} />
          </Routes>
        </Suspense>
        {/* Bouton WhatsApp flottant sur toutes les pages */}
        <WhatsAppButton />
        {/* Bandeau cookies RGPD */}
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
